import { Moon, Sun } from 'lucide-react'
import { useTheme } from '@shared/lib/theme/use-theme'
import { iconButton } from './ThemeToggle.css'

export function ThemeToggle() {
  const theme = useTheme((state) => state.theme)
  const toggleTheme = useTheme((state) => state.toggleTheme)
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      className={iconButton}
      onClick={toggleTheme}
      aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  )
}
